// @flow
import UserContainer from './containers/UserContainer';

export default UserContainer;